export default __webpack_public_path__ + "static/media/Untitled-4.afddc5ec.png";